
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class EmptyInvoice extends Vue {
  @Prop({ required: true }) type!: 'notAvailable' | 'noPermission';

  get info(): { title: string, description: string, img: string, } {
    if (this.type === 'notAvailable') {
      return {
        title: this.$t('invoices.noItemPrompt.title') as string,
        description: this.$t('invoices.noItemPrompt.description') as string,
        img: 'mascot-no-content',
      };
    }

    return {
      title: this.$t('invoices.noPermissionPrompt.title') as string,
      description: this.$t('invoices.noPermissionPrompt.description') as string,
      img: 'mascot-no-permission',
    };
  }
}
